import moment from 'moment';
import { formatDisplayDate } from 'careit';
import { format, formatDistanceToNow } from 'src/utils/date-fns';

// ----------------------------------------------------------------------

export function fMonth(date) {
  return format(date, 'MMMM yyyy');
}

export function fDate(date) {
  return format(date, 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(date, 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(date, 'dd/MM/yyyy p');
}

export function fToNow(date) {
  return formatDistanceToNow(date, {
    addSuffix: true,
  });
}

/**
 * Format a date with its weekday, e.g. "Mon, Oct 12, 2026", so weekday
 * patterns such as recurring pickups stand out in tables.
 *
 * @param {Date | moment | string} date A moment keeps its own zone.
 * @param {{ time?: boolean }} [options] Append the time, "Mon, Oct 12, 2026 8:30 PM".
 * @returns {string} Empty for a missing or invalid date.
 */
export function fWeekdayDate(date, { time = false } = {}) {
  if (!date) {
    return '';
  }
  return formatDisplayDate(moment(date), 'weekdayDate', { time });
}

// DataGrid `renderCell`s for date columns. They only change what the cell
// shows: sorting and filtering keep using the column's value, and CSV exports
// keep using its valueFormatter.
export const renderWeekdayDate = ({ value }) => fWeekdayDate(value);

export const renderWeekdayDateTime = ({ value }) =>
  fWeekdayDate(value, { time: true });
